import { useCallback } from "react";
import { useUserState } from "./useUserState";

const DEFAULTS = { enabled: false };

/**
 * Whether the checklist shows the vehicle's warning lights, remembered per user.
 *
 * Off by default: shown, they are asked of Geotab on every refresh of the live window.
 */
export function useShowTellTales() {
  const { value, setValue } = useUserState("checklist:tellTales", DEFAULTS);

  const setEnabled = useCallback((enabled: boolean) => setValue({ enabled }), [setValue]);

  return { enabled: value.enabled === true, setEnabled };
}
